import { MenuInterface } from '../../../entities';

export const HeaderMenus: { globalMenu: MenuInterface[]; primary: MenuInterface[]; secondary: MenuInterface[] } = {
  globalMenu: [],
  primary: [
    {
      href: 'https://kr.benzinga.com/news/korea/',
      label: '한국 뉴스',
      subGroupChevron: true,
      subnav: {
        action: 'Navigation',
        category: 'Toolbar',
        links: [
          { href: 'https://kr.benzinga.com/news/korea/stocks/', label: '주식', title: '주식' },
          { href: 'https://kr.benzinga.com/news/korea/indices/', label: '지수', title: '지수' },
          { href: 'https://kr.benzinga.com/news/korea/bonds/', label: '채권', title: '채권' },
          { href: 'https://kr.benzinga.com/news/korea/etfs/', label: 'ETFs', title: 'ETFs' },
          { href: 'https://kr.benzinga.com/news/korea/economy/', label: '경제', title: '경제' },
          { href: 'https://kr.benzinga.com/news/korea/general/', label: '일반', title: '일반' },
        ],
      },
      title: '한국 뉴스',
      width: '57px',
    },
    {
      href: 'https://kr.benzinga.com/news/usa/',
      label: '미국 뉴스',
      subGroupChevron: true,
      subnav: {
        action: 'Navigation',
        category: 'Toolbar',
        links: [
          {
            href: 'https://kr.benzinga.com/news/usa/stocks/',
            label: '주식',
            title: '주식',
          },
          {
            href: 'https://kr.benzinga.com/news/usa/indices/',
            label: '지수',
            title: '지수',
          },
          {
            href: 'https://kr.benzinga.com/news/usa/earnings/',
            label: '실적',
            title: '실적',
          },
          {
            href: 'https://kr.benzinga.com/news/usa/economy/',
            label: '경제',
            title: '경제',
          },
          {
            href: 'https://kr.benzinga.com/news/usa/othermarkets/',
            label: '기타 시장',
            title: '기타 시장',
          },
          {
            href: 'https://kr.benzinga.com/news/usa/analystratings/',
            label: '애널리스트 평가',
            title: '애널리스트 평가',
          },
          {
            href: 'https://kr.benzinga.com/news/usa/trading/',
            label: '트레이딩',
            title: '트레이딩',
          },
          {
            href: 'https://kr.benzinga.com/news/usa/pressreleases/',
            label: '보도자료',
            title: '보도자료',
          },
        ],
      },
      width: '75px',
    },
    {
      href: 'https://kr.benzinga.com/news/global/',
      label: '글로벌 뉴스',
      subGroupChevron: true,
      subnav: {
        action: 'Navigation',
        category: 'Toolbar',
        links: [
          {
            href: 'https://kr.benzinga.com/news/global/europe/',
            label: '유럽',
            title: '유럽',
          },
          {
            href: 'https://kr.benzinga.com/news/global/asia/',
            label: '아시아',
            title: '아시아',
          },
        ],
      },
      title: '글로벌 뉴스',
      width: '57px',
    },
    {
      href: 'https://kr.benzinga.com/crypto/',
      label: '암호화폐',
      subGroupChevron: true,
      subnav: {
        action: 'Navigation',
        category: 'Toolbar',
        links: [
          {
            href: 'https://kr.benzinga.com/crypto/altcoins/',
            label: '알트코인',
            title: '알트코인',
          },
          {
            href: 'https://kr.benzinga.com/crypto/bitcoin/',
            label: '비트코인',
            title: '비트코인',
          },
          {
            href: 'https://kr.benzinga.com/crypto/blockchain/',
            label: '블록체인',
            title: '블록체인',
          },
          {
            href: 'https://kr.benzinga.com/category/crypto/dogecoin/',
            label: '도지코인',
            title: '도지코인',
          },
          {
            href: 'https://kr.benzinga.com/category/crypto/ethereum/',
            label: '이더리움',
            title: '이더리움',
          },
          {
            href: 'https://kr.benzinga.com/category/crypto/shiba-inu/',
            label: '시바 이누',
            title: '시바 이누',
          },
          {
            href: 'https://kr.benzinga.com/crypto/nfts/',
            label: 'NFTs',
            title: 'NFTs',
          },
        ],
      },
      title: '암호화폐',
      width: '57px',
    },
    {
      href: 'https://kr.benzinga.com/education/',
      label: '교육 센터',
      subGroupChevron: true,
      subnav: {
        action: 'Navigation',
        category: 'Toolbar',
        links: [
          {
            href: 'https://kr.benzinga.com/education/how-to-invest-in-crypto/',
            label: '암호화폐 투자',
            title: '암호화폐 투자',
          },
          {
            href: 'https://kr.benzinga.com/education/forex/',
            label: '외환',
            title: '외환',
          },
          {
            href: 'https://kr.benzinga.com/education/how-to-invest-in-stocks/',
            label: '주식 투자',
            title: '주식 투자',
          },
        ],
      },
      title: '교육 센터',
      width: '57px',
    },
  ],
  secondary: [],
};
